import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  BulkMakeupActivityRequest,
  MakeupActivityModel,
  MakeupActivityRequest,
  MakeupActivityScheduleRequest,
} from '@tsin-core/models/makeup-activity.model';
import { environment } from '@tsin-env/environment';
import { Observable } from 'rxjs';

const MAKEUP_URL = `${environment.learningBaseUrl}/makeup`;

@Injectable({
  providedIn: 'root',
})
export class MakeupActivityService {
  http: HttpClient = inject(HttpClient);

  getMakeupActivities(payload: MakeupActivityScheduleRequest): Observable<MakeupActivityModel[]> {
    return this.http.get<MakeupActivityModel[]>(
      `${MAKEUP_URL}/absences/${payload.weeklyScheduleId}/${payload.sessionId}`
    );
  }

  getMakeupActivitiesByWeekly(weeklyScheduleId: string): Observable<MakeupActivityModel[]> {
    return this.http.get<MakeupActivityModel[]>(`${MAKEUP_URL}/absences/${weeklyScheduleId}`);
  }

  updateMakeupActivity(payload: MakeupActivityRequest): Observable<MakeupActivityModel> {
    return this.http.patch<MakeupActivityModel>(`${MAKEUP_URL}/mark-completed`, payload);
  }

  /**
   * Submit makeup status for multiple learners in one request.
   * Soumettre le statut de rattrapage pour plusieurs apprenants en une seule requête.
   */
  bulkMarkCompleted(payload: BulkMakeupActivityRequest): Observable<any> {
    return this.http.post(`${MAKEUP_URL}/bulk-mark-completed`, payload);
  }
}
